export const projectsPrivateRoutesConstants = {
  root: {
    path: "/r/app/projects",
    href: () => "/r/app/projects"
  },
  settings: {
    path: "/r/app/projects/settings",
    href: (projectId: string) => `/r/app/projects/settings?project=${projectId}`
  },
  integrations_settings: {
    path: "/r/app/projects/settings/integrations",
    href: (projectId: string) =>
      `/r/app/projects/settings/integrations?project=${projectId}`
  },
  notifications_settings: {
    path: "/r/app/projects/settings/notifications",
    href: (projectId: string) =>
      `/r/app/projects/settings/notifications?project=${projectId}`
  },
  shared_experiments_list: {
    path: "/r/app/projects/settings/shared_experiments_lists",
    href: (projectId: string) =>
      `/r/app/projects/settings/shared_experiments_lists?project=${projectId}`
  },
  shared_roadmaps: {
    path: "/r/app/projects/settings/shared_roadmaps",
    href: (projectId: string) =>
      `/r/app/projects/settings/shared_roadmaps?project=${projectId}`
  },
  project_details: {
    path: "/r/app/projects/settings/project_details",
    href: (projectId: string) =>
      `/r/app/projects/settings/project_details?project=${projectId}`
  },
  teams: {
    path: "/r/app/projects/settings/teams",
    href: (projectId: string) =>
      `/r/app/projects/settings/teams?project=${projectId}`
  }
} as const;
